<template>
  <v-menu offset-y>
    <template v-slot:activator="{ on }">
      <v-btn v-on="on" color="primary" depressed>
        {{ langs[$i18n.locale].name }}
        <v-icon>mdi-menu-down</v-icon>
      </v-btn>
    </template>
    <v-list>
      <template v-for="lang in langs">
        <v-list-item
          @click="selectLang(lang.lang)"
          :key="lang.lang"
        >
          <v-list-item-content>
            <v-list-item-title v-html="lang.name"></v-list-item-title>
          </v-list-item-content>
        </v-list-item>
      </template>
    </v-list>
  </v-menu>
</template>

<script>
export default {
  name: 'lang_selector',
  data: function(){
    var langs
    return {
      module_id: "54",
      // この時点でthis.$store.getters.langsは有効でない
      langs: require('../lang/langs.json')
    }
  },
  mounted: function(){
  },
  methods: {
    selectLang: function(lang){
      this.$i18n.locale = lang;
      this.$vuetify.lang.current = lang;
    }
  }
}

</script>
